import { InjectedConnector } from '@web3-react/injected-connector';
import { NetworkConnector } from '@web3-react/network-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';

export const injected = new InjectedConnector({
  supportedChainIds: [1],
});

export const network = new NetworkConnector({
  urls: {
    1: 'https://mainnet.infura.io/v3/8fc6340cde624d33874ca8603ddaa502',
  },
  defaultChainId: 1,
});

export const walletConnect = new WalletConnectConnector({
  rpc: {
    1: 'https://mainnet.infura.io/v3/8fc6340cde624d33874ca8603ddaa502',
  },
  bridge: 'https://bridge.walletconnect.org',
  qrcode: true,
  pollingInterval: 12000,
});
